var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'uuid/v4'. '/Users/dkrajnak/workspace/aviso/sse-frontend/react/node_modules/uuid/v4.js' implicitly has an 'any' type.
import * as uuid from "uuid/v4";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
import MessageAttachmentButton from "../../Container/Message/MessageAttachment/MessageAttachmentButton";
import { AttachButton } from "../../UI/StandardButtons/StandardButtons";
import { MAXIMUM_ATTACHMENTS_SIZE } from "../../../Domain/Attachment/Attachment.model";
import { UPLOAD_CONFIG, getAcceptedFileTypesDisplay, } from "../../../Config/upload.config";
import Attachment from "../Attachment/Attachment";
import useAsyncTransform from "../../Hooks/useAsyncTransform";
import AttachmentService from "../../../Services/Attachment.service";
import useEditList from "../../Hooks/useEditList";
import useLoadingList from "../../Hooks/useLoadingList";
import FileUtils from "../../../../util/fileUtils";
import { AlertError, AlertSuccess, } from "../../UI/StandardAlerts/StandardAlerts";
import MessageService from "../../../Services/Message.service";
import useUniqueId from "../../Hooks/useUniqueId";
import EmailOrSMSForm, { EMAIL_OR_SMS_DEFAULTS, } from "./EmailOrSMSForm";
import Loading from "../../UI/Loading/Loading";
import AvisoLogService from "../../../Services/AvisoLog.service";
import PopulationService from "../../../Services/Population.service";
const MessageToFilterModal = (_a) => {
    var { populationId, populationName, numStudentsReturnedByPopulation } = _a, modalProps = __rest(_a, ["populationId", "populationName", "numStudentsReturnedByPopulation"]);
    const [draftId, setDraftId] = React.useState(null);
    const uploadAttemptRef = React.useRef(0);
    // Define clearErrors function before it's used
    const clearErrors = () => {
        setFrontendErrors([]);
        setBackendErrors([]);
    };
    React.useEffect(() => {
        if (modalProps.isOpen) {
            setDraftId(uuid());
        }
    }, [modalProps.isOpen]);
    const makeId = useUniqueId()[1];
    const [numStudentsReturnedByPopulationInternal, setNumStudentsReturnedByPopulationInternal,] = React.useState(null);
    React.useEffect(() => {
        if (modalProps.isOpen) {
            PopulationService.getPopulationCount(populationId).then(setNumStudentsReturnedByPopulationInternal);
            clearErrors(); // Clear any previous errors when modal opens
            uploadAttemptRef.current = 0; // Reset upload attempt counter
        }
    }, [populationId, modalProps.isOpen]);
    const numStudentsInFilterFinal = numStudentsReturnedByPopulation || numStudentsReturnedByPopulationInternal;
    // prettier-ignore
    // eslint-disable-next-line no-unused-vars
    const [userAddedFiles, _userAddedAttachments, uploadFiles, , resetUserAddedFiles] = useAsyncTransform(AttachmentService.uploadFiles);
    const [userAddedAttachments, userAddedAttachmentActions] = useEditList(_userAddedAttachments, React.useMemo(() => ({ getId: (attachment) => attachment.attachmentId }), []));
    React.useEffect(() => {
        if (modalProps.isOpen) {
            // Reset when the modal is open in case any attachments were transformed while it was closed.
            resetUserAddedFiles();
        }
    }, [modalProps.isOpen, resetUserAddedFiles, userAddedAttachmentActions]);
    // Clear errors when attachments are successfully added
    React.useEffect(() => {
        if (userAddedAttachments.length > 0) {
            // If we have successful attachments, clear any previous errors
            clearErrors();
        }
    }, [userAddedAttachments.length]);
    const [attachmentsBeingRemoved, _removeAttachment] = useLoadingList(AttachmentService.removeAttachment);
    const removeAttachment = (attachmentId) => {
        if (!draftId) {
            return Promise.reject("Draft Id not defined");
        }
        return _removeAttachment([attachmentId], attachmentId, draftId).then(() => userAddedAttachmentActions.deleteItem(attachmentId));
    };
    const attachmentIsBeingRemoved = React.useCallback((attachmentId) => attachmentsBeingRemoved.includes(attachmentId), [attachmentsBeingRemoved]);
    const totalAttachmentSize = userAddedAttachments.reduce((sum, attachment) => sum + (attachment.size || 0), 0);
    // Frontend and Backend Error Handling
    const [frontendErrors, setFrontendErrors] = React.useState([]);
    const [backendErrors, setBackendErrors] = React.useState([]);
    const handleFileSelection = (files, size) => {
        // Clear previous errors immediately
        clearErrors();
        if (draftId) {
            const filesSize = files.reduce((sum, file) => sum + file.size, 0);
            if (filesSize + totalAttachmentSize > MAXIMUM_ATTACHMENTS_SIZE) {
                setFrontendErrors([
                    `Maximum Attachment size exceeded. All message attachments must be under ${FileUtils.formatBytes(MAXIMUM_ATTACHMENTS_SIZE)}`,
                ]);
                return;
            }
            // Increment upload attempt counter to track current upload
            uploadAttemptRef.current += 1;
            const currentAttempt = uploadAttemptRef.current;
            // Upload files and handle backend errors
            uploadFiles(files, files, draftId).catch((error) => {
                var _a, _b;
                // Only set errors if this is still the current upload attempt
                if (currentAttempt === uploadAttemptRef.current) {
                    console.error("File upload error:", error);
                    // Handle backend errors
                    if ((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) {
                        setBackendErrors([error.response.data.message]);
                    }
                    else if (typeof error === "string") {
                        setBackendErrors([error]);
                    }
                    else {
                        setBackendErrors(["File upload failed. Please try again."]);
                    }
                }
            });
        }
    };
    const allErrors = [...frontendErrors, ...backendErrors];
    React.useEffect(() => {
        if (modalProps.isOpen) {
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            AvisoLogService.info(`Opened message to filter modal with filter ${populationId} (or filter changed while modal was open)`);
        }
    }, [populationId, modalProps.isOpen]);
    return (_jsx(ModalFormFormat, Object.assign({}, modalProps, { defaultValue: EMAIL_OR_SMS_DEFAULTS, keepModalOpenAfterSuccess: _jsx(AlertSuccess, { message: _jsxs(_Fragment, { children: ["Messages successfully sent to\u00A0", _jsx("strong", { children: populationName }), numStudentsInFilterFinal != null ? (_jsxs(_Fragment, { children: ["\u00A0which has\u00A0", _jsx("strong", { children: numStudentsInFilterFinal }), "\u00A0people."] })) : (".")] }) }), onModalClosed: () => {
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            AvisoLogService.info("Closed message to filter modal");
            if (draftId) {
                AttachmentService.removeDirectory(draftId);
            }
            clearErrors();
            modalProps.onModalClosed();
        }, modalTitle: "New Message", confirmSubmit: numStudentsInFilterFinal
            ? `You are sending this message to a filter of ${numStudentsInFilterFinal} students.  Are you sure you want to proceed?`
            : "You are sending this message to a filter.  Are you sure you want to proceed?", saveButtonContents: (isLoading) => (_jsxs(_Fragment, { children: [isLoading && _jsx(Loading, { addMarginRight: true }), "Send"] })), handleSubmit: (form) => __awaiter(void 0, void 0, void 0, function* () {
            var _b, _c;
            if (form.isEmail === "true") {
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                AvisoLogService.info(`Submitted form for email message to filter modal with filter ${populationId}`);
                yield MessageService.sendEmailToPopulation(populationId, {
                    subject: form.subject,
                    body: form.body,
                    sendToInstitutional: form.sendToInstitutional,
                    sendToPersonal: form.sendToPersonal,
                    attachmentIds: (((_c = (_b = form.template) === null || _b === void 0 ? void 0 : _b.attachments) === null || _c === void 0 ? void 0 : _c.map((att) => att.attachmentId)) || []).concat(userAddedAttachments.map((attachment) => attachment.attachmentId)),
                    logMessage: form.logMessage,
                    noteTypeIds: form.noteFromMessage
                        ? form.selectedNoteTypes.map((noteType) => noteType.id)
                        : [],
                    inlineAttachments: form.inlineAttachments || false,
                });
            }
            else {
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                AvisoLogService.info(`Submitted form for text message to filter modal with filter ${populationId}`);
                yield MessageService.sendTextToPopulation(populationId, {
                    smsBody: form.smsBody,
                    noteTypeIds: form.noteFromMessage
                        ? form.selectedNoteTypes.map((noteType) => noteType.id)
                        : [],
                    logMessage: form.logMessage,
                });
            }
        }), footerLeftButton: (formValues) => formValues.watch("isEmail") !== "false" && (_jsxs("div", { children: [allErrors.length > 0 && (_jsx("div", { className: "mb-3", children: allErrors.map((error, index) => (_jsx(AlertError, { message: error }, index))) })), _jsx(MessageAttachmentButton, { button: _jsx(AttachButton, { className: "mr-auto" }), totalSize: userAddedAttachments.reduce((sum, att) => sum + (att.size || 0), 0) +
                        userAddedFiles.reduce((sum, file) => sum + (file.size || 0), 0), existingFilesCount: 0, onChange: handleFileSelection, onError: (error) => {
                        // Increment upload attempt to invalidate any pending upload errors
                        uploadAttemptRef.current += 1;
                        clearErrors();
                        setFrontendErrors(error ? [error] : []);
                    } }), _jsx("div", { className: "mt-2", children: _jsxs("small", { className: "text-muted", children: ["Accepted file types: ", getAcceptedFileTypesDisplay(), ". Maximum", " ", UPLOAD_CONFIG.MAX_FILES, " files per upload. Total size of all attachments: 30MB."] }) })] })), children: (formProps) => {
            var _a;
            return (_jsxs(_Fragment, { children: [_jsx(EmailOrSMSForm, Object.assign({}, formProps, { preamble: _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("filterLabel"), children: "Filter" }), _jsxs("div", { id: makeId("filterLabel"), children: [populationName, " ", numStudentsInFilterFinal != null &&
                                            `(${numStudentsInFilterFinal})`] })] }) })), _jsxs("div", { className: "form-group d-flex flex-wrap", children: [(((_a = formProps.watch("template")) === null || _a === void 0 ? void 0 : _a.attachments) || []).map(
                            // @ts-expect-error - TS7006 - Parameter 'attachment' implicitly has an 'any' type. | TS7006 - Parameter 'index' implicitly has an 'any' type.
                            (attachment, index) => (_jsx(Attachment, { attachment: attachment, className: "mb-3 mr-3" }, index))), userAddedAttachments.map((attachment, index) => (_jsx(Attachment, { attachment: attachment, removeAttachment: () => {
                                    removeAttachment(attachment.attachmentId);
                                }, className: "mb-3 mr-3", isLoading: attachmentIsBeingRemoved(attachment.attachmentId) }, index))), userAddedFiles.map((file, index) => (_jsx(Attachment, { attachment: file, className: "mb-3 mr-3", isLoading: true }, index)))] })] }));
        } })));
};
export default MessageToFilterModal;
